import React from 'react';
import { Image  } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { IoMdClose } from "react-icons/io";

function OrderModal(props) {
    const { t } = useTranslation();
    const lang = sessionStorage.getItem('lang')  || 'en';
    return (
        <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
            <div className='mt-2 mx-1'>
                <Button aria-label="Aria label" className='btn-close' onClick={props.onHide}><IoMdClose size={20} /></Button>
            </div>
            <Modal.Body className="pt-0">
                <Container>
                    {props.page !== 'Orders' && 
                    <>
                    <div className='text-center'>
                        <Image alt="image" src={props?.data.ItemImage} className='img-fluid max-h-200' />
                    </div>
                    <div className='flex-gap-2 justify-content-between flex-wrap fw-semibold mt-3 fs-6'>
                        <p className='mb-1'>{lang === 'ar' && props.data?.ItemNameAr ? props.data?.ItemNameAr : props.data?.ItemNameEn}</p>
                        <p className='mb-1'>$ {props.data.ItemPrice}</p>
                    </div>
                    <div className='subtitle fw-normal font-12'>{props.data?.ItemDescription}</div>
                    <div className='flex-gap-2 justify-content-between flex-wrap fw-semibold mt-2'>
                        <div className='d-flex gap-4'>
                            <div>
                                <p className='mb-0 subtitle font-12'>{t('Item Number')}:</p>
                                <p className='mb-0'>#{props.data.Id}</p>
                            </div>
                            {props.page !== 'items' &&
                                <div>
                                    <p className='mb-0 subtitle font-12'>{t('Profit')}:</p>
                                    <p className='mb-0'>{props.data.Profit}</p>
                                </div>
                            }
                        </div>
                        {props.page !== 'items' && (props.data.Status === '1' ? <div className="status px-5 py-2 status-success"><p className="mb-0">{t('Paid')}</p></div> : <div className="status px-5 py-2 status-failed"><p className="mb-0">{t('Not Paid')}</p></div>)}
                    </div></>}
                    <div>{props.children}</div>
                </Container>
            </Modal.Body>

        </Modal>
    );
}



export default OrderModal;